import React, { useState } from 'react'
import { Pressable, StyleSheet } from 'react-native'
import { Menu } from 'react-native-paper'
import { MaterialIcons } from '@expo/vector-icons'
import { DS } from '@/design-system'
import { translate } from '../../i18n'

const RETENTION_OPTIONS: { label: string; days: number }[] = [
  { label: '7 Days', days: 7 },
  { label: '14 Days', days: 14 },
  { label: '30 Days', days: 30 },
  { label: '60 Days', days: 60 },
  { label: '90 Days', days: 90 }
]

function labelForDays(days: number): string {
  const match = RETENTION_OPTIONS.find((o) => o.days === days)
  return match ? match.label : `${days} Days`
}

type RetentionDropdownProps = {
  value: number
  onChange: (days: number) => void
}

export function RetentionDropdown({ value, onChange }: RetentionDropdownProps) {
  const [open, setOpen] = useState(false)

  return (
    <Menu
      visible={open}
      onDismiss={() => setOpen(false)}
      anchor={
        <Pressable
          onPress={() => setOpen(true)}
          style={styles.button}
          accessibilityRole="button"
          accessibilityLabel={translate('loungeConfigurationScreen.chatSettings.retentionDropdownLabel')}
        >
          <DS.Text variant="Body Large/Regular" style={{ color: DS.palette['Brand/Dark Grey'] }}>
            {labelForDays(value)}
          </DS.Text>
          <MaterialIcons name="arrow-drop-down" size={20} color={DS.palette['Brand/Dark Grey']} />
        </Pressable>
      }
      contentStyle={styles.menuContent}
    >
      {RETENTION_OPTIONS.map((opt) => (
        <Menu.Item
          key={opt.days}
          title={opt.label}
          onPress={() => {
            onChange(opt.days)
            setOpen(false)
          }}
          titleStyle={opt.days === value ? styles.activeTitle : styles.title}
          trailingIcon={opt.days === value ? () => <DS.Icon name="Check" color="Brand/Maroon" size={16} /> : undefined}
        />
      ))}
    </Menu>
  )
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 4
  },
  menuContent: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 10,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  title: {
    color: DS.palette['Global/Black']
  },
  activeTitle: {
    color: DS.palette['Brand/Maroon']
  }
})
